import { PureComponent, ReactNode } from 'react';

import { showModal } from 'zustand-stores/modalStore';

type Props = {
  listingId: string;
  listingType: string;
  userType?: string;
  userContextListingType?: string;
  userContextListingId?: string;
  render: (arg0: { flagListing: () => void }) => ReactNode;
};
type State = {
  flagged: boolean;
};

export class FlagListingContainer extends PureComponent<Props, State> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/state-in-constructor
  state = {
    flagged: false,
  };

  showFlagListingModal = () => {
    const {
      listingId,
      listingType,
      userType,
      userContextListingType,
      userContextListingId,
    } = this.props;
    showModal('FLAG_LISTING', {
      listingId,
      listingType,
      userType,
      userContextListingType,
      userContextListingId,
      onFlagged: () => {
        this.setState({
          flagged: true,
        });
      },
    });
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (this.state.flagged) {
      return null;
    }

    return (
      <>
        {
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          this.props.render({
            flagListing: this.showFlagListingModal,
          })
        }
      </>
    );
  }
}
